const wslink = process.env.NODE_ENV == 'development' ? 'ws://localhost:9999/api/admin/ws' : 'wss://team.stima.pro/api/admin/ws'
import { defineStore } from 'pinia';

export const WebsocketStore = defineStore('ws', {
  state: () => ({         
    wsconn: undefined,    
    online: false,
    subscribers : [],    
    global : [], //global subscribers    
  }),
  
  getters: {
    conn: (state) =>{

      if (state.wsconn && state.online) return state.wsconn 

      const wss = new WebSocketSingleton(wslink);

      wss.addEventListener('open', (event) => {
        console.log('✅ ws connected');        
        state.online = true
      });

      wss.addEventListener('message', (e) => {
        state.online = true
        let res = JSON.parse(e.data)
        state.subscribers.forEach(p => {if (res.name == p.name && p.handler) p.handler(res) });
        state.global.forEach(handler => { if (handler) handler(res) });        
        console.log('✅ ws data', e.data);
        state.online = true
      });

      wss.addEventListener('close', (event) => {
        state.online = false
        console.log('❌ ws disconnected');
      });

      wss.addEventListener('error', (error) => {
        state.online = false
        console.error('❌ ws error:', error);
      });

      
      state.wsconn = wss      
      return state.wsconn
    }
  },

  actions: {
    
    send(name, req){
      this.conn.send(JSON.stringify({name, req}))
    },
    
    // subscribe name
    subscribe(name, handler){this.subscribers.push({name, handler})},
    // subscribe global
    handler(handler){
      this.global.push(handler)
      console.log("ws subscribe global", handler)
    },
    
    

  },
})


class WebSocketSingleton {
  static instance = null;
  static getInstance(url, protocols = []) {
    if (!WebSocketSingleton.instance) {
      WebSocketSingleton.instance = new WebSocketSingleton(url, protocols);
    }
    return WebSocketSingleton.instance;
  }

  constructor(url, protocols = []) {
    if (WebSocketSingleton.instance) {
      return WebSocketSingleton.instance;
    }

    this.url = url;
    this.protocols = protocols;
    this.socket = null;
    this.reconnectAttempts = 0;
    this.maxReconnectAttempts = Infinity;
    this.reconnectInterval = 5000;
    this.forcedClose = false;
    this.eventListeners = {
      open: [],
      close: [],
      error: [],
      message: []
    };

    this.connect();
    WebSocketSingleton.instance = this;
  }

  connect() {
    this.socket = new WebSocket(this.url, this.protocols);

    this.socket.onopen = (event) => {
      this.reconnectAttempts = 0;
      this.dispatch('open', event);
      console.log('ws connected')
    };

    this.socket.onclose = (event) => {
      this.dispatch('close', event);
      if (!this.forcedClose) this.reconnect();
    };

    this.socket.onerror = (event) => {
      this.dispatch('error', event);
    };

    this.socket.onmessage = (event) => {
      this.dispatch('message', event);
    };
  }

  reconnect() {
    if (this.reconnectAttempts >= this.maxReconnectAttempts) {
      console.log(`Max reconnection attempts (${this.maxReconnectAttempts}) reached`);
      return;
    }

    this.reconnectAttempts++;
    console.log(`Reconnecting attempt ${this.reconnectAttempts}...`);

    setTimeout(() => {
      if (!this.forcedClose) this.connect();
    }, this.reconnectInterval);
  }

  send(data) {
    if (this.socket?.readyState === WebSocket.OPEN) {
      this.socket.send(data);
    } else {
      console.error('WebSocket is not connected');
    }
  }

  close() {
    this.forcedClose = true;
    this.socket?.close();
  }

  addEventListener(type, listener) {
    this.eventListeners[type]?.push(listener);
  }

  removeEventListener(type, listener) {
    if (this.eventListeners[type]) {
      this.eventListeners[type] = this.eventListeners[type].filter(
        l => l !== listener
      );
    }
  }

  dispatch(type, event) {
    this.eventListeners[type]?.forEach(listener => listener.call(this, event));
  }

  get readyState() {
    return this.socket?.readyState ?? WebSocket.CLOSED;
  }
}